import { toast } from 'react-toastify';
import { areErrorToastsSuppressed } from './toastSuppression';

/**
 * Gộp toast lỗi trùng nội dung.
 *
 * Nhiều API có thể lỗi cùng lúc trên 1 trang (vd trang chi tiết project gọi
 * nhiều request, tất cả trả 500) → mỗi caller bắn 1 toast "Server error..."
 * giống hệt nhau, dồn thành một chồng toast.
 *
 * react-toastify bỏ qua toast nếu đã có toast cùng `toastId` đang hiển thị.
 * Ta tận dụng điều đó: tự suy `toastId` theo nội dung (khi caller không tự đặt),
 * nên các thông báo GIỐNG nhau chỉ hiện 1; thông báo KHÁC nhau vẫn hiện đủ.
 *
 * Patch 1 lần ở cấp module (import trong src/index.js) nên áp dụng cho toàn bộ
 * ~400 chỗ gọi toast.error mà không phải sửa từng nơi. Caller nào đã tự truyền
 * `toastId` (vd 'http_403') vẫn được tôn trọng.
 */
const patchDedupByContent = method => {
  const original = toast[method].bind(toast);

  toast[method] = (content, options = {}) => {
    // Trang lỗi (403) đang hiển thị → nuốt mọi toast lỗi phát sinh thêm.
    if (areErrorToastsSuppressed()) return null;

    let { toastId } = options;
    if (toastId === undefined && typeof content === 'string') {
      toastId = `${method}:${content}`;
    }
    return original(content, { ...options, toastId });
  };
};

patchDedupByContent('error');
